
<template>

  <div class="notif-outer">
    <div class="notif-content" :style="setContentStyle()">
      <div class="notif-tab"
        :style="{'width': $screen.width > $screen.height ? '30%' : '100%',
        'height': $screen.width > $screen.height ? '100%' : '30%',
        'background-color': setContentStyle().color}"
      >
        <div class="notif-img-buffer">
          <img class="notif-img" :src="setContentStyle().img" />
        </div>
      </div>
      <!-- <div class="vert-separator" v-if="$screen.width > $screen.height" :style="{'background-color': setContentStyle().border.split(' ')[2]}"></div>
      <div class="hor-separator" v-else :style="{'background-color': setContentStyle().border.split(' ')[2]}"></div> -->
      <div class="notif-text" :style="{'width': $screen.width > $screen.height ? '70%' : '90%', 'height': $screen.width > $screen.height ? '90%' : '70%'}">
        <h3 :style="{'color': setContentStyle().color}">{{content.title}}</h3>
        <p>{{content.body}}</p>
        <a class="dismiss-btn" @click="$store.dispatch('dismissNotif')">Dismiss</a>
      </div>
    </div>
  </div>

</template>

<script>

import { mapState } from 'vuex';

const s3Url = 'https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/';

export default {

  data(){
    return {

    }
  },

  computed: mapState({
    notif: state => state.helper.notif,
    content: state => state.helper.notifContent
  }),

  methods: {

    setContentStyle(){
      let style = {};
      style.width = this.$screen.width > this.$screen.height ? '500px' : '350px';
      style.height = this.$screen.width > this.$screen.height ? '350px' : '500px';
      style['flex-direction'] = this.$screen.width > this.$screen.height ? 'row' : 'column';
      switch (this.content.type) {
        case 'err':
          style.color = '#B61416';
          style.img = s3Url + 'critAlert.png';
        break;
        case 'notif':
          style.color = 'rgb(0, 153, 191)';
          style.img = s3Url + 'helperBlue.png';
        break;
        case 'tutorial':
          style.color = '#63A75C';
          style.img = s3Url + 'tutorial.png';
        break;
        case 'cookie':
          style.color = '#dce1ec';
          style.img = s3Url + 'cookieWhite.png';
        break;
      }
      style.border = `2px solid ${style.color}`;
      return style;
    }

  },

  mounted(){

  }

}

</script>

<style>

.notif-outer {
  position: absolute;
  width: 100vw;
  height: 100vh;
  top: 0px;
  background-color: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(7px);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px;
}

.notif-content {
  max-width: 95%;
  max-height: 95%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-radius: 4px;
}

.notif-tab {
  display: flex;
  justify-content: center;
  align-items: center;
  border-top-leftradius: 4px;
  border-bottom-leftradius: 4px;
}

.notif-img-buffer {
  width: 70px;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #191a1a;
  padding: 7px;
  border-radius: 100%;
}

.notif-img {
  width: 55px;
  height: 55px;
}

.vert-separator {
  width: 2px;
  height: 45%;
}

.hor-separator {
  width: 45%;
  height: 2px;
}

.notif-text {
  width: 80%;
  height: 80%;
  padding: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.notif-text h3 {
  width: 80%;
  text-decoration: underline;
  margin-bottom: 2px;
}

.notif-text p {
  color: #dce1ec;
  text-align: left;
}

.dismiss-btn {
  width: 120px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  border: 1px solid #dce1ec;
  cursor: pointer;
  margin-top: 10px;
}

.dismiss-btn:hover {
  background-color: #dce1ec;
  color: rgba(0, 0, 0, 0.75);
}

</style>



// WEBPACK FOOTER //
// src/components/helper/Notif.vue